export default __webpack_public_path__ + "static/media/m&ms.35f342c6.jpg";